const baseApi = process.env.REACT_APP_BASE_API_URL;
const baseApiv2 = process.env.REACT_APP_BASE_API_URL_V2;
const backofficeApi = process.env.REACT_APP_BASE_BACKOFFICE_API;
const backofficeApiv2 = process.env.REACT_APP_BASE_BACKOFFICE_API_V2;

export const baseBOUri = process.env.REACT_APP_BASE_BACKOFFICE_URL;

const oneTrustBaseUrl = process.env.REACT_APP_BASE_ONETRUST_URL;

const wso2BaseApi = process.env.REACT_APP_BASE_WSO2_URL;

const azureApi = process.env.REACT_APP_AZURE_API_URL;
const azureApiv2 = process.env.REACT_APP_AZURE_API_URL_V2;

function getAppends(networks: any[]) {
  let appends = '';
  networks.forEach((el: any) => {
    appends = appends.concat(('&networks=' + el).toString());
  });

  return appends;
}

function getAppendss(networks: any[]) {
  let appends = '';
  networks.forEach((el: any) => {
    appends = appends.concat(('networks=' + el).toString());
  });

  return appends;
}

function getDoctorIdsAppends(doctors: any[]) {
  let appends = '';
  doctors.forEach((el: any) => {
    appends = appends.concat(('&doctorIds=' + el).toString());
  });

  return appends;
}

export const uriPostConsentReceipts = () =>
  `${oneTrustBaseUrl}/request/v1/consentreceipts`;

export const uriGetUserConsents = (nif: number) =>
  `${baseApiv2}/users/${nif}/consents`;

export const uriGetWithdrawConsent = (nif: number, purposeId: string) =>
  `${baseApiv2}/users/${nif}/withdraw-consents/${purposeId}`;

export const uriGetInsuranceInYourHandsCheckboxValue = (
  buId: string,
  memId: string,
) => `${baseApiv2}/members/eed-property?buId=${buId}&memId=${memId}`;

export const uriPatchThirdPartyAuthorizedUsers = () =>
  `${baseApiv2}/members/permissions`;

export const uriGetThirdPartyAuthorizedUsers = (
  buId: string,
  memId: string,
  memIdAuth?: string,
) =>
  memIdAuth
    ? `${baseApiv2}/members/permissions?buId=${buId}&memId=${memId}&memIdAuthorized=${memIdAuth}`
    : `${baseApiv2}/members/permissions?buId=${buId}&memId=${memId}`;

export const uriUpdateInsuranceInYourHandsCheckboxValue = () =>
  `${baseApiv2}/members/eed-property`;

export const uriGetListConsents = () =>
  `${baseApiv2}/users/fetch-external-consents`;

export const uriSendConsents = () => `${baseApiv2}/users/external-consents`;

export const uriGetUserByTaxNumber = (taxNumber: string, dob: string) =>
  `${baseApiv2}/users/${taxNumber}/${dob}/contacts-to-register`;

export const uriGetBus = () => `${baseApiv2}/bus`;

export const getFaqs = () =>
  `https://prdadvancecare-43360e-cd.azurewebsites.net/api/Services/mFAQ`;

export const uriRequestActivationCode = () =>
  `${baseApiv2}/activations/send-activation-code`;

export const uriConfirmActivationCode = (code: string, sessionGuid: string) =>
  `${baseApiv2}/activations/validate/${code}?sessionGuid=${sessionGuid}`;

export const uriCreateUser = () => `${baseApiv2}/users`;
export const uriCreateUserV2 = (sessionId: string) =>
  `${baseApiv2}/users/${sessionId}`;

export const uriUserBu = (nif: string, dob: string) =>
  `${baseApi}/account/${nif}/${dob}`;

export const uriUserBuV2 = (nif: string, dob: string) =>
  `${baseApiv2}/users/${nif}/${dob}/authorized-members`;

export const uriUserBuOnlineOnly = (
  nif: string,
  dob: string,
  onlineOnly: boolean,
) =>
  `${baseApiv2}/users/${nif}/${dob}/authorized-members?isMedicoOnline=${onlineOnly}`;

//gets the card that the user needs
export const uriCard = (bu: string, memId: string, famId: string) =>
  `${baseApiv2}/cards?buId=${bu}&memId=${memId}&famId=${famId}`;

//gets the new card from the other api. returns an array for now if exists and 404 if doesn't
export const uriGetNewCard = (nif: string, dob: string, memid: string) =>
  `${baseApi}/account/${nif}/${dob}/${memid}`;

export const uriGetNewCardV2 = (nif: string) =>
  `${baseApiv2}/users/non-clients/${nif}/validate`;

export const uriCleanUser = () => {
  return `${baseApiv2}/users`;
};

export const uriLogout = () => {
  return `${wso2BaseApi}/oidc/logout`;
};

export const uriGetNewCardNewData = (
  nif: string,
  dob: string,
  buId: string,
  memId: string,
) => `${baseApi}/account/${dob}/${buId}/${memId}/${nif}`;

export const uriAccountSaveData = (nif: string) =>
  `${baseApiv2}/users/non-clients/${nif}`;

// Lista de categorias:
export const uriGetCategoryList = (buId: string, memId: string) =>
  `${baseApiv2}/coverages/categories?buId=${buId}&memId=${memId}`;

//Lista para o ecra do historico:
export const uriGetInsuranceHistoryList = (
  buId: string,
  memId: string,
  dosFrom: string,
  dosThru: string,
  catCode?: string,
) =>
  catCode
    ? // ? `${baseApi}/claim/consumptions/bu/${buId}/mem/${memId}/0/${dosFrom}/${dosThru}/9999?catCode=${catCode}`
      // : `${baseApi}/claim/consumptions/bu/${buId}/mem/${memId}/0/${dosFrom}/${dosThru}/9999`;
      `${baseApiv2}/claims/consumptions?buId=${buId}&memId=${memId}&start=0&dosFrom=${dosFrom}&dosThru=${dosThru}&quantity=9999&catCode=${catCode}`
    : `${baseApiv2}/claims/consumptions?buId=${buId}&memId=${memId}&start=0&dosFrom=${dosFrom}&dosThru=${dosThru}&quantity=9999`;

//Para saber o detalhe de um consumo da lista de consumos:
export const uriGetInsuranceHistoryDetail = (
  buId: string,
  auditNbr: string,
  isCat9: number,
  catCode: string,
) => {
  //const url = `${baseApi}/claim/consumption/detail`;
  const url = `${baseApiv2}/claims/consumptions-detail`;
  let queryParams = '?';
  if (buId) {
    queryParams += `buId=${buId}&`;
  }
  if (auditNbr) {
    queryParams += `auditNbr=${auditNbr}&`;
  }
  if (isCat9) {
    queryParams += `isCat9=${isCat9}&`;
  }
  if (catCode) {
    queryParams += `catCode=${catCode}&`;
  }

  return url + queryParams;
};

export const uriIrsList = (buId: string, memId: string, year: string) =>
  `${baseApiv2}/irs/latest?buId=${buId}&memId=${memId}`;

export const uriDownloadPdf = (
  buId: string,
  memId: string,
  apolice: string,
  prd: string,
  tipoDec: string,
  tipoEnvio: string,
  anoR: string,
  anoDec: string,
) =>
  `${baseApi}/account/irs/pdf/bu/${buId}/mem/${memId}/irs/${apolice}/${prd}/${tipoDec}/${tipoEnvio}/${anoR}/${anoDec}/document`;

// export const uriLogin = () => `${baseApi}/identity/user/login`;

// export const uriLogout = () => `${baseApi}/identity/user/logout`;

// export const uriRefreshToken = () => `${baseApi}/identity/user/token`;

export const uriStatuses = (
  service: 'EXPENSE_SUBMISSION' | 'PRE_AUTHOTIZATIONS' = 'EXPENSE_SUBMISSION',
) => `${baseApiv2}/status?service=${service}`;

export const uriIreneCoverages = (buId: string, benNbr: string) =>
  `${baseApiv2}/coverages/coverage-rules?buid=${buId}&benNbr=${benNbr}`;

export const uriRefunds = (
  buId: string,
  memId: string,
  start: number,
  dosFrom: string | undefined,
  dosThru: string | undefined,
  quantity: number,
  catcode?: string,
  estado?: string,
  order?: string,
  orderby?: string,
  source?: string,
) => {
  let url = `${baseApiv2}/claims/refunds?buId=${buId}&memId=${memId}&start=${start}&dosFrom=${dosFrom}&dosThru=${dosThru}&quantity=${quantity}&`;
  let queryParams = '';

  if (catcode) {
    queryParams += `catCode=${catcode}&`;
  }
  if (estado) {
    queryParams += `stateId=${estado}&`;
  }
  if (order) {
    queryParams += `order=${order}&`;
  }
  if (orderby) {
    queryParams += `orderBy=${orderby}&`;
  }
  if (source) {
    queryParams += `source=${source}`;
  }

  return url + queryParams;
};

export const uriRefundDetails = (
  buId: string | undefined,
  auditNbr: string | undefined,
  processNbr: string | undefined,
  sessionId: string | undefined,
  isCat9: number | undefined,
  catcode: string | undefined,
  isPortal: boolean = true,
) => {
  //let url = `${baseApi}/claim/refund/detail`;
  let url = `${baseApiv2}/claims/refunds-detail`;
  let queryParams = '?';
  if (buId) {
    queryParams += `buId=${buId}&`;
  }
  if (auditNbr) {
    queryParams += `auditNbr=${auditNbr}&`;
  }
  if (processNbr) {
    queryParams += `processNbr=${processNbr}&`;
  }
  if (sessionId) {
    queryParams += `sessionId=${sessionId}&`;
  }
  if (isCat9) {
    queryParams += `isCat9=${isCat9}&`;
  }
  if (catcode) {
    queryParams += `catcode=${catcode}&`;
  }

  queryParams += `isPortal=${isPortal}`;

  return url + queryParams;
};

export const uriRefundPaymentDetails = (buId: string, paymentNumber: number) =>
  `${baseApiv2}/claims/refunds-payment-detail?buId=${buId}&paymentNumber=${paymentNumber}`;

export const uriExpenseSubmission = () => `${baseApi}/ocr/expenseSubmissionv2`;

export const UriProgressBar = (sessionId: string) => {
  let url = `${baseApi}/ocr/progressBar/${sessionId}`;
  return url;
};

export const uriExpenseSubmitionToAdvSystem = () =>
  `${baseApi}/ocr/expenseSubmissionToAdvSystemv2`;

export const uriNewExpenseSubmitionToAdvSystem = () => `${baseApiv2}/expenses`;

export const uriMemberData = (buId: string, memId: string, famId: string) =>
  `${baseApiv2}/members?buid=${buId}&memId=${memId}&famId=${famId}`;

export const uriMemberDataSubmit = () => `${baseApiv2}/members`;
export const uriSendActivationCode = (
  username?: string,
  sessionGuid?: string,
) => `${baseApiv2}/activations/send-reset-password`;
export const uriResendActivationCode = (
  username: string,
  sessionGuid: string,
) =>
  `${baseApiv2}/activation/user/resendActivationCodeToResetPassword/${username}/${sessionGuid}`;

export const uriResetPassword = () => `${baseApiv2}/users/reset-password`;

export const uriGetEmailByTaxNumber = (nif: string) =>
  `${baseApiv2}/users/${nif}/username-recover`;

export const uriUpdateMemberdata = () => `${baseApiv2}/members`;

export const uriUpdateUserdata = () => `${baseApiv2}/users`;

export const uriChangePassword = () => `${baseApiv2}/users/me/update-password`;

export const uriPreAutorizations = (
  memId: string,
  buId: string,
  start: number,
  quantity: number,
  dosFrom: string | undefined,
  dosThru: string | undefined,
  svcgrp?: string,
  processStatus?: string,
  order?: string,
  orderby?: string,
) => {
  let url = `${baseApiv2}/pre-authorizations/member?memId=${memId}&buId=${buId}&start=${start}&quantity=${quantity}&dateFrom=${dosFrom}&dateThru=${dosThru}&`;
  let queryParams = '';

  if (svcgrp) {
    queryParams += `svcGroup=${svcgrp}&`;
  }
  if (processStatus) {
    queryParams += `processStatus=${processStatus}&`;
  }
  if (order) {
    queryParams += `order=${order}&`;
  }
  if (orderby) {
    queryParams += `orderBy=${orderby}&`;
  }
  return url + queryParams;
};
// export const uriGetPreAutorizationDetail = (
//   buId: string,
//   serviceNbr: string
// ) => {
//   return `${baseApiv2}/pre-authorizations/detail?buId=${buId}&ServiceNbr=${serviceNbr}`;
// };

export const uriGetProcedures = (buId: string) =>
  `${backofficeApiv2}/bus/pre-auth-procedures?buAlias=${buId}`;

export const uriGetDocumentTypes = () =>
  `${baseApiv2}/pre-authorizations/documents-type`;

export const uriSubmitPreAuthorization = () =>
  `${baseApiv2}/pre-authorizations`;

export const uriGetIrsLast3Years = (buId: string, memId: string) =>
  `${baseApiv2}/irs/latest?buId=${buId}&memId=${memId}`;

export const uriGetTheIRSpdf = (
  buId: string,
  memId: string,
  ano: string,
  split: string,
) =>
  `${baseApiv2}/irs/pdf?buId=${buId}&memId=${memId}&year=${ano}&split=${split}`;

export const uriGetProvider = () => `${baseApi}/sgr/provider`;

export const uriSubmitComplaint = () => `${baseApi}/sgr/submitv2`;

export const uriSearchProvider = (nif: string, name: string) =>
  nif
    ? name
      ? `${baseApi}/sgr/provider?nif=${nif}&name=${name}`
      : `${baseApi}/sgr/provider?nif=${nif}`
    : name
      ? `${baseApi}/sgr/provider?name=${name}`
      : `${baseApi}/sgr/provider`;

export const uriGetSinisterDocuments = (buId: string, auditNbr: string) =>
  `${baseApiv2}/claims/documents?buId=${buId}&auditNbr=${auditNbr}`;

export const uriGetSinisterDocumentDownload = (id: string) =>
  `${baseApiv2}/claims/documents/${id}`;

export const uriGetHealthScore = (nif: string, healthScore: boolean) =>
  `${baseApiv2}/health-score/${nif}?healthScore=${healthScore}`;

export const uriUpdateDigitalCommunications = (nif: string) =>
  `${baseApiv2}/members/eed-property/${nif}`;

export const uriGetTopCoverages = (
  buId: string,
  memId: string,
  benNbr: number,
) => `${baseApi}/benefit/coberturas/top/${buId}/${memId}/${benNbr}`;

export const uriGetTopV2Coverages = (
  buId: string,
  memId: string,
  benNbr: number,
) => `${baseApiv2}/coverages/top?buId=${buId}&memId=${memId}&benNbr=${benNbr}`;
//`${baseApi}/benefit/coberturas/topV2/${buId}/${memId}/${benNbr}`;

export const uriGetTopDetailCoverages = (
  buId: string,
  benNbr: number,
  catCode: number,
) => `${baseApi}/benefit/coberturas/top/detail/${buId}/${benNbr}/${catCode}`;

export const uriGetTopDetailV2Coverages = (
  buId: string,
  benNbr: number,
  catCode: number,
  memId: string,
) =>
  `${baseApiv2}/coverages/top-detail?buId=${buId}&benNbr=${benNbr}&idReg=${catCode}&memId=${memId}`;

export const uriGetTopDetailCoverageConsumption = (
  buId: string,
  memId: string,
  benNbr: number,
  idReg: number,
  limitSvcNbr: string,
) =>
  `${baseApiv2}/coverages/top-detail-consumption?buId=${buId}&memId=${memId}&benNbr=${benNbr}&idReg=${idReg}&limitSvcNbr=${limitSvcNbr}`;

export const uriMediktor = (buId: string, memId: string) =>
  buId
    ? `${baseApiv2}/symptom-assessor?memId=${memId}&buId=${buId}`
    : `${baseApiv2}/symptom-assessor?memId=${memId}`;

export const uriGetProductMembers = (nif: string, dob: string) =>
  `${baseApiv2}/users/${nif}/${dob}/members`;

export const uriGetTitular = (buId: string, famId: string) =>
  `${baseApiv2}/members/owner?buId=${buId}&famId=${famId}`;

export const uriUpdateBannerLoginState = () => `${baseApiv2}/banners`;

export const uriBannerLoginState = (
  bannerAlias: string,
  hasLink: string,
  username: string,
) => `${baseApiv2}/banners?bannerAlias=${bannerAlias}&hasLink=${hasLink}`;

export const uriGetNetwork = () => `${azureApiv2}/medical-network`;

export const uriGetLocations = () => `${azureApiv2}/medical-network/locations`;

export const uriGetNetworkSearch = (
  query: string,
  location: string,
  networks: number[],
  take: number,
  skip: number,
) => {
  const appends = getAppends(networks);
  return `${azureApiv2}/medical-network/search?skip=${skip}&take=${take}&query=${query}&location=${location}&${appends}`;
};

export const uriGetClinicProcedure = (
  procedure: number,
  skip: any,
  location: any,
  networks: number[],
) => {
  const appends = getAppends(networks);
  return `${azureApiv2}/medical-network/clinics/procedures/${procedure}?location=${location}&order=relevance&direction=0&skip=${skip}&take=10${appends}`;
};

export const uriGetClinicProcedureAlpha = (
  procedure: number,
  skip: any,
  location: any,
  networks: number[],
) => {
  const appends = getAppends(networks);
  return `${azureApiv2}/medical-network/clinics/procedures/${procedure}?location=${location}&order=name&direction=0&skip=${skip}&take=10${appends}`;
};

export const uriGetClinicGroup = (
  nameHash: string,
  skip: any,
  location: any,
  networks: number[],
) => {
  const appends = getAppends(networks);

  var url = `${azureApiv2}/medical-network/clinics/groups/${nameHash}?location=${location}&order=relevance&direction=0&skip=${skip}&take=10${appends}`;

  return url;
};

export const uriGetClinicGroupAlpha = (
  nameHash: string,
  skip: any,
  location: any,
  networks: number[],
) => {
  const appends = getAppends(networks);

  var url = `${azureApiv2}/medical-network/clinics/groups/${nameHash}?location=${location}&order=name&direction=0&skip=${skip}&take=10${appends}`;

  return url;
};

export const uriPostPasswordCheckResult = () =>
  `${baseApiv2}/users/me/validate-password`;

export const uriCancelAppointment = (id: any, providerId: any) =>
  `${baseApiv2}/appointments/${providerId}/${id}/cancel`;

export const uriGetAppointmentsUpcoming = (bu: any, memID: any) =>
  `${baseApiv2}/appointments/upcoming?buId=${bu}&memId=${memID}`;

export const uriGetAppointmentsPast = (bu: any, memID: any) =>
  `${baseApiv2}/appointments/past?buId=${bu}&memId=${memID}`;

export const uriGetAppointmentsByTime = (
  buId: any,
  memId: any,
  famId: any,
  speciality: any,
  startDate: any,
  startTime: any,
  endDate: any,
  endTime: any,
  ignorePrice: boolean = false,
  procCodeRef: any,
  network: any,
  amtClaimed: any,
  providerId: any,
  practiceSeq: any,
  productExpiryDate: any,
  doctorIds?: any[],
) => {
  const appends = doctorIds ? getDoctorIdsAppends(doctorIds) : '';
  let url = `${baseApiv2}/appointments/doctors/available-slots-by-time?buId=${buId}&memId=${memId}&famId=${famId}&speciality=${speciality}&ignorePrice=${ignorePrice}&startDate=${startDate}&startTime=${startTime}&endDate=${endDate}&endTime=${endTime}${appends}`;
  let queryParams = '&';

  if (procCodeRef) {
    queryParams += `procCodeRef=${procCodeRef}&`;
  }

  if (network) {
    queryParams += `network=${network}&`;
  }

  if (amtClaimed) {
    queryParams += `amtClaimed=${amtClaimed}&`;
  }

  if (providerId) {
    queryParams += `providerId=${providerId}&`;
  }

  if (practiceSeq) {
    queryParams += `practiceSeq=${practiceSeq}&`;
  }

  if (productExpiryDate) {
    queryParams += `productExpiryDate=${productExpiryDate}&`;
  }

  return url + queryParams;
};

export const uriGetAppointmentDaysWithSlots = (
  doctorId: any,
  startDate: any,
  endDate: any,
  providerId: string,
) => {
  return `${baseApiv2}/appointments/doctors/${providerId}/${doctorId}/available-per-day?startDate=${startDate}&endDate=${endDate}`;
};

export const uriGetDoctorsSearchQuery = (name: string) => {
  return `${baseApi}/knok/doctors?query=${name}`;
};

export const uriGetDoctorsSearchQueryv2 = (
  name: string,
  specialities?: any[],
) => {
  let specialitiesQuery = '';
  specialities?.map((speciality: string) => {
    specialitiesQuery += `&specialty=${speciality}`;
  });
  return `${baseApiv2}/appointments/doctors-directory?name=${name}${specialitiesQuery}`;
};

export const uriGetMedic = (medic: number) => {
  return `${azureApiv2}/medical-network/medics/${medic}`;
};

export const uriGetMedicClinics = (medic: number, networks: number[]) => {
  const appends = getAppends(networks);

  var url = `${azureApiv2}/medical-network/medics/${medic}/clinics?${appends}`;

  return url;
};

export const uriGetMedicCategories = (medic: number, networks: number[]) => {
  const appends = getAppends(networks);

  var url = `${azureApiv2}/medical-network/medics/${medic}/categories?${appends}`;

  return url;
};

export const uriGetMedicCategoryProcedures = (
  medic: number,
  networks: number[],
  category: number,
) => {
  const appends = getAppends(networks);

  var url = `${azureApiv2}/medical-network/medics/${medic}/categories/${category}/procedures?skip=0${appends}`;

  return url;
};

export const uriGetClinic = (clinic: number) => {
  return `${azureApiv2}/medical-network/clinics/${clinic}`;
};

export const uriGetClinicCategories = (clinic: number, networks: number[]) => {
  const appends = getAppends(networks);

  var url = `${azureApiv2}/medical-network/clinics/${clinic}/categories?take=10${appends}`;

  return url;
};

export const uriGetClinicCategoriesSpecialities = (
  clinic: any,
  category: number,
  networks: number[],
) => {
  const appends = getAppends(networks);

  var url = `${azureApiv2}/medical-network/clinics/${clinic}/categories/${category}/specialities?skip=0${appends}`;

  return url;
};

export const uriGetClinicSpecialityProcedures = (
  clinic: any,
  speciality: any,
  networks: number[],
  category: number,
) => {
  const appends = getAppends(networks);

  var url = `${azureApiv2}/medical-network/clinics/${clinic}/categories/${category}/specialities/${speciality}/procedures?skip=0${appends}`;

  return url;
};

export const uriGetClinicProcedures = (clinic: number, networks: number[]) => {
  const appends = getAppends(networks);

  var url = `${azureApiv2}/medical-network/clinics/${clinic}/procedures?${appends}`;

  return url;
};
export const uriGetClinicProcedureMedics = (
  clinic: number,
  procedure: number,
  networks: number[],
) => {
  const appends = getAppends(networks);

  return `${azureApiv2}/medical-network/clinics/${clinic}/procedures/${procedure}/medics?skip=0${appends}`;
};

export const uriGetMedicSpecialities = (
  medic: any,
  category: number,
  networks: number[],
) => {
  const appends = getAppends(networks);

  var url = `${azureApiv2}/medical-network/medics/${medic}/categories/${category}/specialities?skip=0${appends}`;

  return url;
};

export const uriGetClinicProcedureMedicsFiltered = (
  clinic: number,
  procedure: number,
  networks: number[],
) => {
  const appends = getAppendss(networks);

  return `${azureApiv2}/medical-network/clinics/${clinic}/procedures/${procedure}/medics?${appends}`;
};

export const uriGetMedicSpecialityProcedures = (
  medic: any,
  speciality: number,
  category: number,
  networks: number[],
) => {
  const appends = getAppends(networks);

  var url = `${azureApiv2}/medical-network/medics/${medic}/categories/${category}/speciality/${speciality}/procedures?skip=0${appends}`;

  return url;
};

//Exames Accordion - Medics for selected Procedure
export const uriGetMedicsExamesProcedures = (
  clinic: any,
  procedure: number,
  networks: number[],
) => {
  const appends = getAppends(networks);

  return `${azureApiv2}/medical-network/clinics/${clinic}/procedures/${procedure}/medics?skip=0${appends}`;
};

export const uriGetProcedureClinic = (
  procedure: number,
  clinic: number,
  networks: number[],
) => {
  const appends = getAppends(networks);

  return `${azureApiv2}/medical-network/clinics/${clinic}/procedures?${appends}`;
};

export const uriGetAppointmentData = (provider: string, id: any) =>
  `${baseApiv2}/appointments/${provider}/${id}`;

export const uriUploadAppointmentFile = (id: any, providerId: any) =>
  `${baseApiv2}/appointments/${providerId}/${id}/upload`;

export const uriGetAppointment = (id: any, providerId: string) =>
  `${baseApiv2}/appointments/${providerId}/${id}/patient-link`;

export const uriGetDoctorsSpeciality = (
  buId: any,
  memId: any,
  famId: any,
  speciality: any,
  ignorePrice: boolean = false,
  procCodeRef: any,
  network: any,
  amtClaimed: any,
  providerId: any,
  practiceSeq: any,
  productExpiryDate: any,
  numberOfDefaultDays?: string | number | undefined,
) => {
  const url = `${baseApiv2}/appointments/doctors/available-slots?buId=${buId}&memId=${memId}&famId=${famId}&speciality=${speciality}&ignorePrice=${ignorePrice}&numberOfDefaultDays=${numberOfDefaultDays}`;
  let queryParams = '&';

  if (procCodeRef) {
    queryParams += `procCodeRef=${procCodeRef}&`;
  }

  if (network) {
    queryParams += `network=${network}&`;
  }

  if (amtClaimed) {
    queryParams += `amtClaimed=${amtClaimed}&`;
  }

  if (providerId) {
    queryParams += `providerId=${providerId}&`;
  }

  if (practiceSeq) {
    queryParams += `practiceSeq=${practiceSeq}&`;
  }

  if (productExpiryDate) {
    queryParams += `productExpiryDate=${productExpiryDate}`;
  }

  return url + queryParams;
};

export const uriPostAppointment = () => `${baseApiv2}/appointments`;

export const uriPutAppointment = (providerId: string, id: number) =>
  `${baseApiv2}/appointments/${providerId}/${id}`;

export const uriPostCountClicks = () =>
  `${baseApiv2}/medical-network/count-clicks`;

export const uriGetTenants = (alias?: string) => {
  // return `${backofficeApi}/tenants?alias=${alias}`;
  return `${backofficeApiv2}/tenants`;
};

export const uriCurrencies = () => {
  // return `${backofficeApi}/currency-codes`;
  return `${backofficeApiv2}/currency-codes`;
};

export const uriUserInfo = () => `${baseApiv2}/users/me/claims`;

export const putUserPersonalDate = () =>
  `${baseApiv2}/users/me/claims/personal-date`;
export const uriGetUserByTaxNumberCMD = (taxNumber: string) =>
  `${baseApiv2}/users/${taxNumber}/registered`;

export const getDataFromCMD = () => {
  return `${baseApiv2}/cmd/attributes`;
};

export const uriGetBuStylesFromBuAlias = (buAlias: string) => {
  // return `${backofficeApi}/bus?alias=${buAlias}`;
  return `${backofficeApiv2}/bus?buAlias=${buAlias}`;
};

export const uriGetGroupExceptionsFromBuAlias = (buAlias: string) =>
  `${backofficeApiv2}/bus/group-exceptions?buAlias=${buAlias}`;

export const uriGetProductExceptionsFromBuAlias = (buAlias: string) =>
  `${backofficeApiv2}/bus/product-exceptions?buAlias=${buAlias}`;

export const uriGetDeducts = (buAlias: string) =>
  `${backofficeApiv2}/bus/deducts?buAlias=${buAlias}`;

export const uriGetCampaigns = (buAlias: string) =>
  `${backofficeApiv2}/campaigns?buAlias=${buAlias}`;

export const uriGetSpecialties = () => `${backofficeApiv2}/specialties`;

export const uriGetFunctionalities = (buAlias?: string) => {
  return `${backofficeApiv2}/bus/features?buAlias=${buAlias}`;
};

export const uriGetServicesBO = () => `${backofficeApiv2}/bus/services`;

export const uriGetServiceDetails = (id: any) =>
  `${backofficeApiv2}/bus/${id}/services`;

export const uriGetServices = (
  buId: string,
  productNumber: number,
  benNumber: number,
) =>
  `${baseApiv2}/services/common?buId=${buId}&productNumber=${productNumber}&benNbr=${benNumber}`;

export const uriGetServicesNC = (buId: string) =>
  `${baseApiv2}/services/common?buId=${buId}`;

export const getAppointmentSpecialities = (buId: string, benNbr: string) => {
  return `${baseApiv2}/appointments/specialties?buId=${buId}&benNbr=${benNbr}`;
};

export const getAppointmentSpecialitiesDetail = () => {
  return `${baseApiv2}/backoffice/specialties`;
};

export const getAppointmentSpecialitiesBO = () => {
  return `${backofficeApiv2}/specialties`;
};

export const uriGetPreAuthDocuments = (
  buId: string,
  serviceNumber: string,
  occurrenceNumber: string,
) => {
  return `${baseApiv2}/pre-authorizations/documents?buId=${buId}&serviceNumber=${serviceNumber}&occurrenceNumber=${occurrenceNumber}`;
};

export const getPreAuthDocsBase64 = (
  buId: string,
  serviceNumber: string,
  occurrenceNumber: string,
  notificationId: string,
) =>
  `${baseApiv2}/pre-authorizations/documents/download?buId=${buId}&occurrenceNumber=${occurrenceNumber}&serviceNumber=${serviceNumber}&notificationId=${notificationId}`;

export const getPartialRefusalReasons = (buAlias: string, code: string) => {
  return `${backofficeApiv2}/bus/partial-refusal-reasons?buAlias=${buAlias}&code=${code}`;
};

export const uriGetPriceFile = () => {
  return `${baseApiv2}/backoffice/medical-network-segments`;
};

export const uriSendOTPCode = () => {
  return `${baseApiv2}/activations/send-otp-code-update-contacts`;
};

export const uriPatchContacts = () => {
  return `${baseApiv2}/users/me/contacts`;
};

export const uriValidateRegisterData = (nif: string, dob: string) => {
  return `${baseApiv2}/members/${nif}/${dob}/validate`;
};

export const uriValidateMember = (sessionId: string) =>
  `${baseApiv2}/users/${sessionId}/member-validation`;

export const uriPostContactsToRegister = (sessionId: string) =>
  `${baseApiv2}/users/${sessionId}/contacts-to-register`;

export const uriCardValidate = () =>
  `${baseApiv2}/members/nif/card-validate`;

export const uriStartRegister = () => `${baseApiv2}/users/start-register`;
